<app-table-field-button
  [table-field]="cellParams.tableField"
  [document-id]="cellParams.data.id"
  [document-secure-id]="cellParams.data.secureId"
  [show-label]="false"
></app-table-field-button>
